import $ from "cash-dom";

export const sliderInputComponent = (root, {min, max, step, defaultValue}) => {
    const $root = $(root);
    const slider = $root.find('.slider').get(0);
    const sliderIndicator = $root.find('.slider-indicator').get(0);
    const sliderButton = $root.find('.slider-button').get(0);
    const sliderLabel = $root.find('.slider-label').get(0);
    const sliderLabelValue = $root.find('.slider-label-value').get(0);
    const input = $root.find('input').get(0);

    let previousValue;

    const formatValue = value => Math.abs(value).toLocaleString('sk');
    const parseValue = value => parseInt(value.replace(/\D/g, ''));
    const clamp = (value) => Math.max(min, Math.min(max, value));
    const toPercentage = value => ((value - min) / (max - min)) * 100;
    const fromPercentage = value => clamp(Math.round((value * (max - min) + min) / step) * step);

    const setValue = newValue => {
        const percentage = `${toPercentage(newValue)}%`;

        previousValue = newValue;
        sliderIndicator.style.width = sliderButton.style.left = sliderLabel.style.left = percentage;
        sliderLabelValue.innerText = input.value = formatValue(previousValue);
    };

    const Input = {
        onChange() {
            const value = parseValue(input.value);
            if (!isNaN(value))
                setValue(clamp(value, min, max));
            else
                setValue(previousValue);
        },
    };

    const Slider = {
        isActive: false,
        onMouseDown(x) {
            setValue(fromPercentage(x / slider.clientWidth));
            Slider.isActive = true;
        },
        onMouseMove(x) {
            if (Slider.isActive)
                setValue(fromPercentage(x / slider.clientWidth));
        },
        onMouseUp() {
            if (Slider.isActive)
                Slider.isActive = false;
        },
    };

    const getLeftOffset = e => e.pageX - slider.getBoundingClientRect().x + window.scrollX;

    input.onchange = Input.onChange;

    slider.onmousedown = e => Slider.onMouseDown(getLeftOffset(e));
    window.addEventListener('mousemove', e => Slider.onMouseMove(getLeftOffset(e)));
    window.addEventListener('mouseup', () => Slider.onMouseUp());

    slider.ontouchstart = e => {
        e.preventDefault();
        if (e.touches.length === 1)
            Slider.onMouseDown(getLeftOffset(e.touches[0]));
    };
    slider.ontouchmove = e => {
        e.preventDefault();
        if (e.touches.length === 1)
            Slider.onMouseMove(getLeftOffset(e.touches[0]));
    };
    slider.ontouchend = e => {
        e.preventDefault();
        if (e.touches.length <= 0)
            Slider.onMouseUp();
    };

    setValue(defaultValue);
};
